import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { mapState } from 'vuex';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import editInsureModal from './editInsureModal.vue';
import confirmInsureModal from './confirmInsureModal.vue';
import { failColumn } from '../utils';
import { policyBatchSave, policyBatchCheckField, failBatchPolicy } from '../request';
import { uploadFile } from '../request';
export default {
  components: {
    editInsureModal,
    confirmInsureModal
  },
  props: ['visible', 'isFail', 'data', 'column', 'templateRenderList', 'fileList'],
  data() {
    const h = this.$createElement;
    return {
      indicator: h("a-icon", {
        "attrs": {
          "type": "loading",
          "spin": true
        },
        "style": "font-size: 24px"
      }),
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共') + total + this.$t('条')}`;
        }
      },
      showColumns: failColumn,
      showData: this.data,
      selectedRowKeys: [],
      editVisible: false,
      editIndex: -1,
      myTemplateRenderList: {},
      confirmVisible: false,
      toInsureData: [],
      fileUrl: '',
      hasError: false,
      loading: false
    };
  },
  watch: {
    visible(newV) {
      if (newV) {
        this.close();
      }
    },
    data: {
      handler(newV) {
        console.log(newV, 'newV');
        this.hasError = false;
        let errorLines = newV.filter(i => {
          var _i$errorMessage;
          return ((_i$errorMessage = i.errorMessage) === null || _i$errorMessage === void 0 ? void 0 : _i$errorMessage.length) > 0;
        });
        if (errorLines.length) {
          this.showData = errorLines;
          this.hasError = true;
        } else {
          this.showData = newV;
        }
      },
      deep: true
    },
    column: {
      handler(newV) {
        this.showColumns = newV;
      },
      deep: true
    },
    templateRenderList: {
      handler(newV) {
        console.log(newV, 'templateRenderList');
        this.myTemplateRenderList = recursionCopy(newV);
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      accountInfo: state => state.user.accountInfo
    })
  },
  methods: {
    updateTemplateAndSave() {
      console.log(this.fileList, 'this.fileList');
      if (this.fileList.length) {
        let formData = new FormData();
        formData.append('file', this.fileList[0].originFileObj);
        formData.append('module', 'auditAttachment');
        console.log(formData, this.fileList[0].originFileObj, 'formData');
        uploadFile(formData).then(res => {
          this.fileUrl = res.fileTempUrl || '';
          this.onFinish();
        }).catch(() => {
          this.$message.error(this.$t('上传文件失败'));
        });
      }
    },
    updateTemplate(data) {
      this.myTemplateRenderList = recursionCopy(data.templateRenderList);
      console.log(this.myTemplateRenderList, 'this.myTemplateRenderList');
      this.showData = data.showData;
    },
    getClassName(item) {
      var _item$errorMessage;
      return ((_item$errorMessage = item.errorMessage) === null || _item$errorMessage === void 0 ? void 0 : _item$errorMessage.length) > 0 ? 'red-row-class' : '';
    },
    // 再次投保
    async againInsure() {
      if (this.selectedRowKeys.length) {
        let indexs = [];
        if (this.showData.findIndex(i => {
          var _i$errorMessage2;
          return this.selectedRowKeys.includes(i.id) && ((_i$errorMessage2 = i.errorMessage) === null || _i$errorMessage2 === void 0 ? void 0 : _i$errorMessage2.length) > 0;
        }) > -1) {
          this.$message.destroy();
          return this.$message.warn(this.$t('存在错误数据'));
        }
        this.showData.forEach((item, index) => {
          if (this.selectedRowKeys.includes(item.id)) {
            indexs.push(index);
          }
        });
        let newTemplateRenderList = recursionCopy(this.myTemplateRenderList);
        newTemplateRenderList.insuredInfo = newTemplateRenderList.insuredInfo.filter((item, index) => {
          return indexs.includes(index);
        });
        newTemplateRenderList.customerId = this.accountInfo.customerId;
        // this.myTemplateRenderList.batchPolicyId = this.accountInfo.customerId;
        let insuredInfo = recursionCopy(newTemplateRenderList);
        insuredInfo = insuredInfo.insuredInfo.map(item => {
          if (item !== null && item !== void 0 && item.commonInfo) {
            item.commonInfo = item.commonInfo.commonTemplate;
          }
          if (item !== null && item !== void 0 && item.insured) {
            item.insured = [item.insured];
          }
          return item;
        });
        let params = {
          insuranceId: newTemplateRenderList.insuranceId,
          insuredInfo
        };
        const res = await policyBatchCheckField(params);
        let passRes = res.insuredInfo.findIndex(i => i.isCheck);
        if (passRes > -1) {
          // 传回有错误信息数据 标红
          res.insuredInfo.forEach((item, index) => {
            if (item.isCheck) {
              this.showData[index].errorMessage.push(item.errorMessage);
            }
          });
        } else {
          const result = await failBatchPolicy(newTemplateRenderList);
          this.toInsureData = {
            customerInsuranceName: result.customerInsuranceName,
            insureCount: result.insureCount,
            totalAmount: result.totalAmount,
            totalActualAmount: result.totalActualAmount,
            id: newTemplateRenderList.batchPolicyId,
            customerId: newTemplateRenderList.customerId
          };
          this.confirmVisible = true;
          this.$emit('finish');
        }
      } else {
        this.$message.destroy();
        this.$message.warn(this.$t('请选择需要再次投保的数据'));
      }
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    delCurrent(index) {
      if ((this.pagination.current - 1) * this.pagination.pageSize + index >= this.myTemplateRenderList.insuredInfo.length) {
        this.pagination.current = this.pagination.current - 1 < 1 ? 1 : this.pagination.current - 1;
      }
      // if (
      //   index + this.pagination.pageSize * (this.pagination.current - 1) >
      //   this.myTemplateRenderList.insuredInfo.length
      // ) {
      //   this.showData.splice(index + this.pagination.pageSize * (this.pagination.current - 2), 1);
      //   this.myTemplateRenderList.insuredInfo.splice(
      //     index + this.pagination.pageSize * (this.pagination.current - 2),
      //     1
      //   );
      // } else {
      //   this.showData.splice(index + this.pagination.pageSize * (this.pagination.current - 1), 1);
      //   this.myTemplateRenderList.insuredInfo.splice(
      //     index + this.pagination.pageSize * (this.pagination.current - 1),
      //     1
      //   );
      // }
      this.showData.splice(index + this.pagination.pageSize * (this.pagination.current - 1), 1);
      this.myTemplateRenderList.insuredInfo.splice(index + this.pagination.pageSize * (this.pagination.current - 1), 1);
      this.$message.destroy();
      this.$message.success(this.$t('删除成功'));
    },
    editInfo(index) {
      if ((this.pagination.current - 1) * this.pagination.pageSize + index >= this.myTemplateRenderList.insuredInfo.length) {
        this.pagination.current = this.pagination.current - 1 < 1 ? 1 : this.pagination.current - 1;
      }
      // if (
      //   index + this.pagination.pageSize * (this.pagination.current - 1) >
      //   this.myTemplateRenderList.insuredInfo.length
      // ) {
      //   this.editIndex = index + this.pagination.pageSize * (this.pagination.current - 2);
      // } else {
      this.editIndex = index + this.pagination.pageSize * (this.pagination.current - 1);
      // }
      this.editVisible = true;
    },
    handleStandardTableChange(val) {
      this.pagination = val;
    },
    async onFinish() {
      if (this.data.length) {
        if (this.data.findIndex(i => {
          var _i$errorMessage3;
          return ((_i$errorMessage3 = i.errorMessage) === null || _i$errorMessage3 === void 0 ? void 0 : _i$errorMessage3.length) > 0;
        }) < 0) {
          this.myTemplateRenderList.customerId = this.accountInfo.customerId;
          let insuredInfo = recursionCopy(this.myTemplateRenderList);
          console.log(insuredInfo, this.myTemplateRenderList, 'insuredInfo');
          insuredInfo = insuredInfo.insuredInfo.map(item => {
            if (item !== null && item !== void 0 && item.commonInfo) {
              item.commonInfo = item.commonInfo.commonTemplate;
            }
            if (item !== null && item !== void 0 && item.insured) {
              item.insured = [item.insured];
            }
            return item;
          });
          let params = {
            insuranceId: this.myTemplateRenderList.insuranceId,
            insuredInfo
          };
          // const res = await policyBatchCheckField(params);
          // let passRes = res.insuredInfo.findIndex(i => i.isCheck);
          // if (passRes > -1) {
          //   // 传回有错误信息数据 标红
          //   res.insuredInfo.forEach((item, index) => {
          //     if (item.isCheck) {
          //       if (item.applicant && item.applicant.length) {
          //         item.applicant.forEach((i, ind) => {
          //           if (i.checkResult) {
          //             this.data[index].errorMessage.push(i.checkResult);
          //           }
          //         });
          //       }
          //       if (item.insured && item.insured[0].length) {
          //         item.insured[0].forEach((i, ind) => {
          //           if (i.checkResult) {
          //             this.data[index].errorMessage.push(i.checkResult);
          //           }
          //         });
          //       }
          //     }
          //   });
          //   this.showData = this.data.filter(i => i.errorMessage?.length > 0);
          // } else {
          this.myTemplateRenderList.fileUrl = this.fileUrl;
          this.loading = true;
          await policyBatchSave(this.myTemplateRenderList).finally(() => {
            this.loading = false;
          });
          this.$message.destroy();
          this.$message.success(this.$t('保存成功'));
          this.close();
          this.$emit('finish');
          this.$router.push({
            path: '/groupOrderManage/batchInsurance'
          });
          // }
        } else {
          let recentErrorPage = parseInt(this.showData.findIndex(i => {
            var _i$errorMessage4;
            return ((_i$errorMessage4 = i.errorMessage) === null || _i$errorMessage4 === void 0 ? void 0 : _i$errorMessage4.length) > 0;
          }) / this.pagination.pageSize) + 1;
          this.pagination.current = recentErrorPage;
          this.$message.destroy();
          this.$message.warn(this.$t('存在错误数据'));
        }
      } else {
        this.$message.destroy();
        this.$message.warn(this.$t('数据为空'));
      }
    },
    close() {
      this.selectedRowKeys = [];
      this.pagination.pageSize = 10;
      this.pagination.current = 1;
    }
  }
};